// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.suggestion-list[data-v-d2a1df1e] {
  min-height: 75px;
}
.suggestion-list[data-v-d2a1df1e] .v-list__tile__content {
  position: relative;
  padding-left: 25px;
}
.suggestion-list[data-v-d2a1df1e] .v-list__tile__content .v-icon {
  position: absolute;
  left: 0px;
}
.suggestion-list[data-v-d2a1df1e] .v-list__tile__sub-title {
  margin-top: 3px;
}
.suggestion-list[data-v-d2a1df1e] .v-list--three-line .v-list__tile {
  height: auto;
  padding: 10px 16px;
}
.job-search[data-v-d2a1df1e] {
  min-height: 100px;
}
.scroll-content-dialog[data-v-d2a1df1e] {
  max-height: 400px;
  position: relative;
}
.record-msg[data-v-d2a1df1e] {
  display: flex;
}
.record-msg span[data-v-d2a1df1e] {
  margin: auto;
}
.job-search[data-v-d2a1df1e] .search-job-item > div {
  position: relative;
}
.job-search[data-v-d2a1df1e] .search-job-item .seach-loader {
  position: absolute !important;
  top: 13px;
  right: 35px;
  margin: 0px;
}
.job-search[data-v-d2a1df1e] .search-job-item .v-input {
  position: relative;
}
.job-search[data-v-d2a1df1e] .search-job-item .v-input .v-input__prepend-outer {
  margin: 0;
}
.job-search[data-v-d2a1df1e] .search-job-item .v-input .v-input__icon--prepend {
  position: absolute;
  left: 0;
}
.job-search[data-v-d2a1df1e] .search-job-item .v-input .v-text-field__details {
  max-width: calc(100% - 0px);
}
.job-search[data-v-d2a1df1e] .search-job-item .v-input__slot {
  padding-left: 40px;
  padding-right: 40px;
}
.job-search[data-v-d2a1df1e] .search-job-item .v-input .v-select__slot .v-input__append-inner {
  position: absolute;
  right: -30px;
}
.popup-close-msg[data-v-d2a1df1e] {
  vertical-align: super;
  position: relative;
  top: 2px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
